module.exports = __webpack_public_path__ + "static/gauntlets_of_ogre_power-29efaab5ba7e823d97d13cd737c399dd.jpg";